//==========================
// 非同期ロードの開始（v1.1）
//==========================
function startReloadCotent() {
  // 重複追加防止
  if (!document.getElementById('PageLoader')) {
    $('body').append("<div id='PageLoader' class='PageLoader' aria-live='polite' aria-busy='true'></div>");
  }
  // 画面全体のbusyを明示（A11y）
  document.body.setAttribute('aria-busy', 'true');
}


// 内部状態（直列化・多重実行対策）
(function () {
  var _inflight = null;        // 進行中のjqXHR
  var _lock = false;           // 実行ロック
  var _lastAbortReason = null; // 直近の中断理由ログ用

  //==========================
  // 非同期ページ更新（v1.1）
  // targetTags = 配列
  // ※remodalはmainに含めない
  //==========================
  window.reloadCotent = function (thisUrl, targetTags, isAddressBarUrlRewrite) {
    // 入口互換：Deferredを返す
    var deferred = new $.Deferred();

    // 引数の軽いバリデーション
    if (!thisUrl || !Array.isArray(targetTags) || targetTags.length === 0) {
      console.warn('[reloadCotent] 引数が不正です。', { thisUrl, targetTags });
      safeFinalize();
      deferred.resolve(); // 互換：常にresolve（既存呼び出しを壊さない）
      return deferred;
    }

    // 直列化：進行中があれば中断（最新リクエストを優先）
    if (_inflight && _inflight.readyState !== 4) {
      _lastAbortReason = 'superseded';
      try { _inflight.abort('superseded'); } catch (e) {}
      _inflight = null;
      _lock = false;
    }
    if (_lock) {
      // 二重ロックの保険（理論上ここには来ない）
      console.warn('[reloadCotent] ロック中のためスキップしました。');
      safeFinalize();
      deferred.resolve();
      return deferred;
    }

    // アドレスバー書き換え（互換挙動：1の時だけreplaceState）
    try {
      if (isAddressBarUrlRewrite == 1 && window.history && history.replaceState) {
        history.replaceState('', '', thisUrl);
      }
    } catch (e) {
      console.warn('[reloadCotent] history.replaceState で例外', e);
    }

    // タイムアウト・リトライ方針
    var TIMEOUT_MS = 10000; // 10秒
    var MAX_RETRY = 1;      // 失敗時の再試行1回
    var retryCount = 0;

    // 実行ロック開始
    _lock = true;

    // ローダー（入口側で未表示でも安全に出す）
    startReloadCotent();

    // 取得→反映のメイン関数
    function runAjaxOnce() {
      var jqxhr = $.ajax({
        url: thisUrl,
        type: 'GET',
        dataType: 'html',
        timeout: TIMEOUT_MS,
        cache: true // 同一URLでも更新される想定ならETag/Last-Modifiedに任せる
      });

      _inflight = jqxhr;

      jqxhr.done(function (html) {
        try {
          // --- All-or-nothing 解析 ---
          // 取得HTMLを安全にパース（外部DOMとして扱う）
          var $tmp = $('<div/>');
          // parseHTMLはSCRIPTも展開されるが、append先は一時divのため実行副作用は生じない
          $tmp.append($.parseHTML(html, document, true));

          // 全セレクタの内容を先に集める
          var extractMap = {};
          var missing = [];
          targetTags.forEach(function (sel) {
            // filter() と find() の両方に対応（従来互換）
            var $hit = $tmp.find(sel);
            if (!$hit.length) $hit = $tmp.filter(sel);
            if ($hit.length) {
              // 中身のみを反映（従来互換）
              extractMap[sel] = $hit.first().html();
            } else {
              missing.push(sel);
            }
          });

          if (missing.length) {
            // 一部でも欠けたら何も変えない（巻き戻し不要）
            console.warn('[reloadCotent] 置換対象が見つかりませんでした。', missing);
            showSoftError('一時的な不具合によりページの一部更新に失敗しました。少し待って再度お試しください。');
            // カスタムイベント：失敗通知
            dispatchPartialEvent('partial:updateFailed', { url: thisUrl, missing: missing.slice() });
            return;
          }

          // --- 反映（全て揃っている前提で一括） ---
          targetTags.forEach(function (sel) {
            var htmlPart = extractMap[sel];
            if (htmlPart === undefined) return;
            $(sel).html(htmlPart);
          });

          // 差し替え後の再初期化フック
          // - ラジオアコーディオン（存在すれば任意rootで再初期化）
          if (typeof window.RadioAccordionInit === 'function') {
            try { window.RadioAccordionInit(document); } catch (e) { console.warn('RadioAccordionInit error', e); }
          }
          // - 固定ナビ/下部固定ウィジェット等の再評価（スクロール・リサイズを一度発火）
          try {
            window.dispatchEvent(new Event('resize'));
            window.dispatchEvent(new Event('scroll'));
          } catch (e) {}

          // カスタムイベント：成功通知（roots=更新領域）
          dispatchPartialEvent('partial:updated', { url: thisUrl, roots: targetTags.slice() });

        } catch (ex) {
          console.error('[reloadCotent] 解析または反映で例外', ex);
          // 解析時例外は再試行対象にしない（HTML構造不整合の可能性が高い）
          showSoftError('ページの更新に失敗しました。時間をおいて再度お試しください。');
          // 失敗イベント
          dispatchPartialEvent('partial:updateFailed', { url: thisUrl, error: String(ex && ex.message || ex) });
        }
      }).fail(function (xhr, status) {
        // 中断は再試行しない
        if (status === 'abort') {
          console.warn('[reloadCotent] リクエストが中断されました:', _lastAbortReason || status);
          _lastAbortReason = null;
          return;
        }
        // タイムアウト・一時的失敗は一回だけ再試行
        if (retryCount < MAX_RETRY) {
          retryCount++;
          var backoff = 400 * retryCount; // 簡易指数バックオフ
          setTimeout(runAjaxOnce, backoff);
          return;
        }
        console.warn('[reloadCotent] 通信エラー:', status, xhr && xhr.status);
        showSoftError('通信状況が安定しないため、更新に失敗しました。回線状況を確認して再度お試しください。');
        dispatchPartialEvent('partial:updateFailed', { url: thisUrl, status: status, httpStatus: xhr && xhr.status });
      }).always(function () {
        // 互換：完了通知（成功/失敗/中断 いずれも）
        deferred.resolve();

        // ロック解除・後片付け
        _inflight = null;
        _lock = false;
        safeFinalize();
      });
    }

    runAjaxOnce();

    // 互換：Deferredを返す
    return deferred;

    //=====================
    // 内部ユーティリティ
    //=====================
    function showSoftError(msg) {
      try {
        // 画面上に控えめな通知（任意の場所でOK。ここではbody直下に一時的に表示）
        var $note = $('<div class="StatP R8 P10 BL-S1-B BL-CCC2" role="status" aria-live="polite"></div>').text(msg);
        $note.css({
          position: 'fixed',
          left: '50%',
          bottom: '16px',
          transform: 'translateX(-50%)',
          background: '#ffe4e1',
          color: '#c03',
          borderColor: '#f5b5b0',
          zIndex: 2000,
          boxShadow: '0 6px 16px rgba(0,0,0,.12)'
        });
        $('body').append($note);
        setTimeout(function () { $note.fadeOut(200, function () { $(this).remove(); }); }, 2800);
      } catch (e) {
        // 最終手段としてalertを残す（従来互換）
        try { alert('ページを更新します'); location.reload(); } catch (_) {}
      }
    }

    function dispatchPartialEvent(type, detail) {
      try {
        var ev = new CustomEvent(type, { detail: detail || {} });
        document.dispatchEvent(ev);
      } catch (e) {
        // IE系互換が不要なら無視
      }
    }

    function safeFinalize() {
      // ローダー除去（存在すれば）
      setTimeout(function () {
        try { $('#PageLoader').remove(); } catch (_) {}
        try { document.body.removeAttribute('aria-busy'); } catch (_) {}
      }, 500);
    }
  };
})();
